import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const acceptBulkEmployeeUpdatesAndSendInvitesKey = 'acceptBulkEmployeeUpdateAcceptUpdatesAndSendInvites';

export interface AcceptBulkEmployeeUpdatesAndSendInvitesState {
  acceptBulkEmployeeUpdatesAndSendInvitesResponse: any;
  acceptBulkEmployeeUpdatesAndSendInvitesFailure: any;
  loaded: boolean;
}

export const initialState: AcceptBulkEmployeeUpdatesAndSendInvitesState = {
  acceptBulkEmployeeUpdatesAndSendInvitesResponse: undefined,
  acceptBulkEmployeeUpdatesAndSendInvitesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.acceptBulkEmployeeUpdatesAndSendInvitesSuccess, (state, action) => ({
    ...state,
    acceptBulkEmployeeUpdatesAndSendInvitesResponse: action.response,
    loaded: true
  })),

  on(actions.acceptBulkEmployeeUpdatesAndSendInvitesFailure, (state, action) => ({
    ...state,
    acceptBulkEmployeeUpdatesAndSendInvitesFailure: action.error
  }))
);

export const acceptBulkEmployeeUpdatesAndSendInvites = (state: AcceptBulkEmployeeUpdatesAndSendInvitesState) =>
  state.acceptBulkEmployeeUpdatesAndSendInvitesResponse;
